import { trimChar } from "..";
import { BaseResource } from "./base.resource";
import { Item } from "./item.resource";
import { UnshippedManifest } from "./manifest.resource";

export const ContainerAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
  Approve: 1 << 3,
  Print: 1 << 4,
  Close: 1 << 5,
};

export class Container extends BaseResource {
  setManifest(manifest: UnshippedManifest) {
    this.manifestId = manifest.id;
    this.trackingNumber = manifest.trackingNumber;
    this.wasteType = manifest.wasteType;
  }
  revision: number;
  containerNumber: string;
  wasteType: string;
  shipped: boolean;
  streamName: string;
  containerDetail: string;
  dotDescription: string;
  binId: string;
  hm: boolean;
  items: Item[];
  ergNumber: string;
  tsdfDisposalCode: string;
  tsdfProfile: string;
  containerType: string;
  open: boolean;
  approved: boolean;
  approvedBy: string;
  approvedDate: Date;
  approvedComments: string;
  enteredBy: string;
  enteredByName: string;
  weight: number;
  weightUnits: string;
  itemsWeight: number;
  volume: number;
  volumeUnits: string;
  get weightUn(): string {
    return this.weight !== null ? this.weight + " " + this.weightUnits : "";
  }
  get volumeUn(): string {
    return this.volume !== null ? this.volume + " " + this.volumeUnits : "";
  }
  stateWasteCode: string;
  wasteCode01: string;
  wasteCode02: string;
  wasteCode03: string;
  wasteCode04: string;
  wasteCode05: string;
  wasteCode06: string;
  wasteCode07: string;
  wasteCode08: string;
  wasteCode09: string;
  wasteCode10: string;
  get wasteCodesJoin(): string {
    let codes = trimChar(
      [
        this.wasteCode01,
        this.wasteCode02,
        this.wasteCode03,
        this.wasteCode04,
        this.wasteCode05,
        this.wasteCode06,
        this.wasteCode07,
        this.wasteCode08,
        this.wasteCode09,
        this.wasteCode10,
      ].join(", "),
      ", "
    );
    return (codes.match(/,/g) || []).length < 5 ? codes : codes.replaceAll(" ", "");
  }
  corrosive: boolean;
  ignitable: boolean;
  reactive: boolean;
  toxic: boolean;
  lab: string;
  level: string;
  mgmtMethodCode: string;
  owner: string;
  ownerName: string;
  phone: string;
  office: string;
  labNo: string;
  organization: string;
  chargeCode: string;
  physicalStateId: string;
  manifestId: number;
  facilityName: string;
  trackingNumber: string;
  hasItems: boolean;
  startDate: Date;
  get startDateStr(): string {
    return this.startDate.toLocaleDateString();
  }
  dueDate: Date;
  createdOn: Date;
  createdBy: string;
  updatedOn: Date;
  updatedBy: string;

  constructor(options?: any) {
    super(options);
    // Initialize properties...
  }
  get isBulk(): boolean {
    return this.wasteType === "Bulk";
  }
  get isLabPack(): boolean {
    return this.wasteType === "LabPack";
  }

  get dotNumber(): string {
    if (!this.dotDescription) return "";

    return this.dotDescription.startsWith("UN") || this.dotDescription.startsWith("NA")
      ? this.dotDescription.substr(0, 6)
      : "";
  }
  get dotText(): string {
    if (!this.dotDescription) return "";
    return this.dotDescription.startsWith("UN") || this.dotDescription.startsWith("NA")
      ? this.dotDescription.substr(6)
      : this.dotDescription;
  }
  get isGas(): boolean {
    return this.physicalStateId === "Gas";
  }
  get isLiquid(): boolean {
    return this.physicalStateId === "Liquid";
  }
  get isSolid(): boolean {
    return this.physicalStateId === "Solid";
  }
  get canView(): boolean {
    return (this.accessLevel & ContainerAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & ContainerAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return !this.hasItems && (this.accessLevel & ContainerAccessLevel.Delete) > 0;
  }
  get canApprove(): boolean {
    return (this.accessLevel & ContainerAccessLevel.Approve) > 0;
  }
  get canPrint(): boolean {
    return (this.accessLevel & ContainerAccessLevel.Print) > 0;
  }
  get canClose(): boolean {
    return (this.accessLevel & ContainerAccessLevel.Close) > 0;
  }
}

export class OpenContainer extends BaseResource {
  containerNumber: string;
  containerDetail: string;
  wasteType: string;
  startDate: Date;
  streamName: string;
  weightUnits: string;
}
